module.exports = function getResource(label) {
    const resources = { qty: 'Quantité' };
    return resources[label];
};
